import { BEConfig } from "../../config/env";
import { fetchWebApi, postDashboardWebApi } from "../../webapis/apiResource";
import { getAccessToken } from "../../util/storeHelper";
import { showLoadingIndicator, hideLoadingIndicator } from "./common.action";
import { handleFetchError } from "../../util/errorHandler";
import { getVisitorId, languageFromPathName } from "../../util";
import { setCheckoutOrder, setCheckoutRequestData } from "./checkout.action";
import { tokenGeneratorCheckoutGuest } from "./authConfig.action";
import { getGuestUserStorage } from "../../util/browserStorage";

import { SET_ORDER_DATA, SET_ORDER_STATUS } from "../constants";
import { COUNTRY_CODE, COUPON_CODE } from "../constants/common";
import { setCookie } from "../../util/browserStorage";

export const setOrder = order => ({ type: SET_ORDER_DATA, order });

export const setOrderStatus = order => ({ type: SET_ORDER_STATUS, order });

export const confirmOrder = (bodyData, history, language, CC = false) => {
  language = languageFromPathName(language);
  const {
    checkoutApi: {
      baseURL,
      protocol,
      port,
      versionInfo,
      checkoutOrderHandle,
      confirmOrderHandle
    }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${
    CC ? confirmOrderHandle : checkoutOrderHandle
  }`;

  return async (dispatch, getState) => {
    const { countryCode } = getState().common.settings;
    const { voucherCode } = getState().checkoutReducer.checkoutData;
    setCookie(COUNTRY_CODE, countryCode);
    if (!CC) setCookie(COUPON_CODE, voucherCode);

    dispatch(setCheckoutRequestData(bodyData));
    dispatch(showLoadingIndicator());

    try {
      const response = await postDashboardWebApi(
        getAccessToken(getState),
        apiURL,
        bodyData,
        getVisitorId()
      );

      const isSuccess =
        response.status === 200 && response.data && response.data.success;
      if (!isSuccess) {
        throw new Error(response.data?.error?.message);
      }

      dispatch(setCheckoutOrder(response.data));

      return response;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};

export const getCCOrderDetails = ({ token, orderId }) => {
  const {
    customerApi: { baseURL, protocol, port, versionInfo, userOrderDetails }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${userOrderDetails}`;

  return async dispatch => {
    dispatch(showLoadingIndicator());
    try {
      const bodyData = { token, orderId };

      const response = await postDashboardWebApi(null, apiURL, { ...bodyData });

      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      return error.message;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};
export const getOrderData = (orderID, language) => {
  language = languageFromPathName(language);
  const {
    customerApi: { baseURL, protocol, port, versionInfo, orderHandle }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${orderHandle}/${orderID}`;
  return async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    const userLoggedIn = getState().authReducer.userLoggedIn;
    if (userLoggedIn === false) {
      dispatch(tokenGeneratorCheckoutGuest(getGuestUserStorage()));
    }
    return fetchWebApi(
      getAccessToken(getState),
      apiURL,
      getVisitorId(),
      language
    )
      .then(response => {
        dispatch(hideLoadingIndicator());
        if (response.status === 200 && response.data?.orderId) {
          dispatch(setOrder(response.data));
        }
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const getOrderStatusData = (token, language) => {
  const {
    customerApi: { baseURL, protocol, port, versionInfo, orderStatus }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${orderStatus}?token=${token}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    return fetchWebApi(
      getAccessToken(getState),
      apiURL,
      getVisitorId(),
      language
    )
      .then(response => {
        dispatch(hideLoadingIndicator());
        if (response.data && response.data.success && response.data) {
          dispatch(setOrderStatus(response.data));
        }
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const sendOtp = bodyData => {
  const {
    checkoutApi: { baseURL, protocol, port, versionInfo, otpHandle }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${otpHandle}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    return postDashboardWebApi(
      getAccessToken(getState) || getGuestUserStorage(),
      apiURL,
      bodyData,
      getVisitorId()
    )
      .then(response => {
        dispatch(hideLoadingIndicator());
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const verifyOtp = bodyData => {
  const {
    checkoutApi: { baseURL, protocol, port, versionInfo, verifyOtpHandle }
  } = BEConfig;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${verifyOtpHandle}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    return postDashboardWebApi(
      getAccessToken(getState) || getGuestUserStorage(),
      apiURL,
      bodyData,
      getVisitorId()
    )
      .then(response => {
        dispatch(hideLoadingIndicator());
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};
